export const DEFAULT_ACTION = "app/RejectedInvoices/DEFAULT_ACTION";
export const CASEUPDATE = "app/RejectedInvoices/CASEUPDATE";

